<div class="bg-color-base-2500 h-100vh">
    <grid-row  class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11"  ipad="8" class="text-align-center">
            <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>
            <!-- <ng-icon iconClass="icon-error background-size-100" width="100" height="100"></ng-icon> -->
                
            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3" >
                {{"YourPaymentHasSuccessfull" | translate}}
            </div>

            <grid-row class="justify-content-center" >
                <grid-col col="10" mobile="11">
                
                    <grid-row class="align-content-center justify-content-between mt-30">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{"AmountPaid" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                                {{"BHD" | translate}} {{this.formattedAmount }}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="align-content-center justify-content-between mt-15">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{"Date" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                               {{this.currentDate |  date : "dd MMM yyyy"}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="align-content-center justify-content-between mt-15">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{"Time" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                               {{this.time |  date : "hh:mm a"}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="align-content-center justify-content-between mt-15">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{"RefID" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                                {{this.RefID }}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="mt-30">
                        <grid-col col="12">
                            <button class="btn-dft-border" (click)="Return()">
                                {{ "Done" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>

            <div class="font-600 font-size-14px color-base-700 line-h-40 mt-10 letter-spacing-1">
                {{"SHARE RECEIPT" | translate}}
            </div>
        </grid-col>
    </grid-row>
</div>
